/* Approved display copies only; never selects product gallery or cart line media. */
(() => {
  const config = document.getElementById('nm-listing-display-map');
  if (!config) return;
  const map = JSON.parse(config.textContent);
  const keys = Object.keys(map);
  const scope = '.nm-product-card, .product-item__wrapper, .nm-bestseller__card, .nm-gw__card, a.product';
  function replace(root) {
    const images = root.matches?.('img') ? [root] : root.querySelectorAll?.('img') || [];
    for (const img of images) {
      if (!img.closest(scope)) continue;
      const values = ['src','data-src','srcset','data-srcset'].map(a => img.getAttribute(a) || '').join(' ');
      const key = keys.find(k => values.includes('/' + k));
      if (!key) continue;
      img.dataset.nmDisplayCopy = key;
      img.removeAttribute('srcset'); img.removeAttribute('data-srcset');
      img.setAttribute('data-src', map[key]); img.src = map[key];
      const picture = img.closest('picture');
      if (picture) picture.querySelectorAll('source').forEach(s => s.remove());
    }
  }
  replace(document);
  new MutationObserver(records => {
    const pending = new Set();
    for (const record of records) {
      if (record.type === 'attributes') pending.add(record.target);
      else for (const node of record.addedNodes) if (node.nodeType === 1) pending.add(node);
    }
    pending.forEach(replace);
  }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','data-src','data-srcset']});
})();
